module.exports = __webpack_public_path__ + "img/home-header-image-original.6f9f42fd.png";